import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import {
  Typography,
  Row,
  Col,
  Form,
  Input,
  Select,
  Alert,
  Modal,
  notification,
  DatePicker,
  Radio,
  Tabs,
  Badge,
} from 'antd';

import {
  CustomButton,
  CustomSelector,
  CustomTooltip,
} from '../../../components';

import AjaxTable from '../../../components/AjaxTable';
import {
  contractSearch,
  newInfo,
  causalSelector,
  post,
  contractSearchCounters,
} from '../../../api/module/postcontractual';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import MESSAGES from '../../../enums/Messages';
import { catchExceptionSRate } from '../../../utils/helpers/helpers';
import { ClockCircleOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const breadcrumbItems = [
  {
    text: 'Módulo Poscontractual',
    to: `${INTERNAL_LINKS.POSTCONTRACTUAL}`,
  },
  {
    text: 'Formulario de Poscontractual',
  },
];

const initCounters = () => ({
  pending: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  running: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  restricted: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  terminated: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  full: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
});

const NewPostContractualForm = ({ match, history, paPerm, sendPerm }) => {
  const [data, setData] = useState();
  const [query, setQuery] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [formModal] = Form.useForm();

  const [counters, setCounters] = useState(initCounters);

  const [newData, setNewData] = useState();
  const [loadingNext, setLoadingNext] = useState();

  useEffect(() => {
    async function fetchData() {
      setData();
      try {
        const res = await newInfo(match.params.project_id);
        setData({ ...res.data, project_id: match.params.project_id });
      } catch (error) {
        console.log(error);
        notification.error({
          message: MESSAGES.ERROR_MSG,
          description: MESSAGES.DESC_ERROR_GET_MSG,
          duration: 2,
        });
      }
    }
    fetchData();
  }, [match.params.project_id]);

  const next = async (postData) => {
    setLoadingNext(newData.contrato);
    postData['fecha_continuar'] = newData.fecha_continuar;
    postData['fecha_interna_maxima'] = newData.fecha_continuar.isBefore(
      newData.fecha_fin,
      'day',
    )
      ? postData.fecha_efectiva.clone().add(newData.plazo, 'days')
      : newData.fecha_fin.clone().add(newData.plazo, 'days');

    const formatedData = Object.entries(postData).reduce((pv, v) => {
      console.log(v, pv);

      if (v[0].startsWith('fecha_')) pv[v[0]] = v[1].format('YYYY-MM-DD');
      else pv[v[0]] = v[1];
      return pv;
    }, {});
    formatedData['contrato'] = newData.contrato;
    try {
      const res = await post(formatedData);
      history.push(`${INTERNAL_LINKS.POSTCONTRACTUAL}-form/${res.data.id}`);
    } catch (error) {
      setLoadingNext();
      catchExceptionSRate(error, MESSAGES.DESC_ERROR_POST_MSG);
    }
  };

  const getCountersData = async (newQuery) => {
    try {
      setCounters(initCounters);
      const res = await contractSearchCounters(newQuery);
      setCounters(res.data.results);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    const newQuery = { ...values, proyecto: data.project_id };
    if (JSON.stringify(newQuery) !== JSON.stringify(query)) {
      setQuery();
      setLoading(true);
      setQuery(newQuery);
      getCountersData(newQuery);
    }
  };

  const columns = [
    {
      title: 'Nombre Contratista/Proveedor',
      dataIndex: 'contratista_nombre',
    },
    {
      title: 'Sigla Doc',
      dataIndex: 'tipo_identificacion',
      width: '5em',
      align: 'center',
    },
    {
      title: 'Nro. Doc',
      dataIndex: 'identificacion',
      width: '14em',
    },
    {
      title: 'Cargo/Rol',
      dataIndex: 'cargo_nombre',
      width: '30em',
    },
    {
      title: 'No. Contrato',
      dataIndex: 'contrato_num',
      width: '8em',
    },
    {
      title: 'Fecha terminación VIGENTE',
      dataIndex: 'fecha_fin',
      width: '8em',
    },
  ];

  const extraColumnsPending = [
    {
      title: 'Acciones',
      key: 'accion',
      align: 'center',
      fixed: 'right',
      width: '20em',
      render: (_, record) => (
        <CustomButton
          type="default"
          text="Crear terminación"
          onClick={() =>
            setNewData({
              ...record,
              contrato: record.id,
              fecha_fin: dayjs(record.fecha_fin),
              fecha_inicio: dayjs(record.fecha_inicio),
              fecha_continuar: dayjs(),
            })
          }
          loading={loadingNext === record.id}
          disabled={loadingNext}
        />
      ),
    },
  ];

  const extraColumnsRunning = [
    {
      title: 'Quién lo tiene',
      dataIndex: 'usuario_actual',
    },
    {
      title: 'Fecha recepción',
      dataIndex: 'fecha_recepcion',
      align: 'center',
    },
    {
      title: 'Tipo acta',
      dataIndex: 'tipo_acta',
    },
    {
      title: 'ID masivo',
      dataIndex: 'id_masivo',
    },
  ];

  const extraColumnsRestricted = [
    {
      title: 'Acciones',
      key: 'accion',
      align: 'center',
      fixed: 'right',
      width: '20em',
      render: (_, record) =>
        record.mod_draft ? (
          'Modificación en curso'
        ) : paPerm ? (
          <Link to={`${INTERNAL_LINKS.PRODUCT_APPROVAL}-form/pc/${record.id}`}>
            <CustomButton
              text="Productos por gestionar"
              type="default"
              disabled={loadingNext}
            />
          </Link>
        ) : (
          <CustomButton
            type="default"
            text="Productos por gestionar"
            onClick={() => {
              Modal.error({
                title: 'Error',
                content:
                  'No tiene permiso para gestionar aprobación de productos, favor contacte con el administrador del sistema.',
              });
            }}
            disabled={loadingNext}
          />
        ),
    },
  ];

  const extraColumnsTerminated = [
    {
      title: 'Tipo acta',
      dataIndex: 'tipo_acta',
    },
  ];

  const extraColumnsFull = [
    {
      title: 'Tipo acta',
      dataIndex: 'tipo_acta',
    },
    {
      title: 'Estado',
      dataIndex: 'status',
    },
  ];

  return (
    <div>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        MÓDULO POSCONTRACTUAL
      </Title>
      <Title level={4}>Proyecto: {data?.project_name}</Title>
      <br />
      <Alert
        showIcon
        type="info"
        message="Información importante"
        description={
          <>
            <b>Terminaciones y Liquidaciones contractuales:</b>
            <br />
            <b>Ordinaria bilateral: </b>Cuando el contrato ha terminado en el
            tiempo y modo pactado.
            <br />
            <b>Ordinaria unilateral: </b>Cuando el contrato se terminó en el
            tiempo y modo pactado, pero no se suscribió el acta de terminación y
            liquidación bilateral en el término establecido en la cláusula de
            terminación y liquidación; por tanto, la organización contratante
            procede a realizarla unilateralmente.
            <br />
            <b>Anticipada bilateral: </b>Cuando las partes acuerdan terminar el
            contrato antes de la fecha de terminación pactada en el contrato.
            <br />
            <b>Anticipada unilateral: </b>Cuando la organización contratante
            decide terminar el contrato antes de la fecha de terminación
            pactada, debido a la configuración de alguna(s) de la(s) causal(es)
            de terminación.
            <br />
          </>
        }
      />
      <br />
      {data && (
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Title level={5}>Búsqueda por identificación</Title>
          <Row align="bottom" gutter={8}>
            <Col span={8}>
              <Form.Item label="Nombre" name="nombre">
                <Input allowClear placeholder="Búsqueda por nombre" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Número de documento" name="documento">
                <Input
                  type="number"
                  allowClear
                  placeholder="Búsqueda por documento"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Correo electrónico" name="correo">
                <Input allowClear placeholder="Correo electrónico" />
              </Form.Item>
            </Col>
          </Row>
          <Title level={5}>Búsqueda por contrato</Title>
          <Row align="bottom" gutter={8}>
            <Col span={12}>
              <Form.Item label="Cargo" name="cargo">
                <Select
                  placeholder="Seleccione un cargo/rol..."
                  allowClear
                  options={data.positions}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Número de Contrato" name="contrato_num">
                <Input allowClear placeholder="Búsqueda por contrato" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8} justify="end">
            <Col>
              <CustomButton loading={loading} text="Buscar" />
            </Col>
            <Col>
              <CustomButton
                htmlType="button"
                type="default"
                onClick={() => {
                  form.resetFields();
                }}
                danger={true}
                text="Borrar filtros"
              />
            </Col>
          </Row>
        </Form>
      )}
      <br />

      {data && query && (
        <Tabs type="card" destroyInactiveTabPane={true} defaultActiveKey={0}>
          <TabPane
            tab={
              <Paragraph>
                Pendientes
                <Badge showZero count={counters.pending} />
              </Paragraph>
            }
            key={0}
          >
            <AjaxTable
              columns={[...columns, ...extraColumnsPending]}
              tableTitle={'Listado de resultados'}
              endpoint={contractSearch}
              query={{ ...query, lt: 0 }}
              sortBy="-contrato_num"
              searchInput
              exportCSV
            />
          </TabPane>
          <TabPane
            tab={
              <Paragraph>
                En curso
                <Badge showZero count={counters.running} />
              </Paragraph>
            }
            key={1}
          >
            <AjaxTable
              columns={[...columns, ...extraColumnsRunning]}
              tableTitle={'Listado de resultados'}
              endpoint={contractSearch}
              query={{ ...query, lt: 1 }}
              sortBy="id_masivo, contratista_nombre"
              searchInput
              exportCSV
            />
          </TabPane>
          <TabPane
            tab={
              <Paragraph>
                Con restricción
                <Badge showZero count={counters.restricted} />
              </Paragraph>
            }
            key={2}
          >
            <AjaxTable
              columns={[...columns, ...extraColumnsRestricted]}
              tableTitle={'Listado de resultados'}
              endpoint={contractSearch}
              query={{ ...query, lt: 2 }}
              sortBy="contratista_nombre"
              searchInput
              exportCSV
            />
          </TabPane>
          <TabPane
            tab={
              <Paragraph>
                Finalizadas
                <Badge showZero count={counters.terminated} />
              </Paragraph>
            }
            key={3}
          >
            <AjaxTable
              columns={[...columns, ...extraColumnsTerminated]}
              tableTitle={'Listado de resultados'}
              endpoint={contractSearch}
              query={{ ...query, lt: 3 }}
              sortBy="contratista_nombre"
              searchInput
              exportCSV
            />
          </TabPane>
          <TabPane
            tab={
              <Paragraph>
                Todos
                <Badge showZero count={counters.full} />
              </Paragraph>
            }
            key={4}
          >
            <AjaxTable
              columns={[...columns, ...extraColumnsFull]}
              tableTitle={'Listado de resultados'}
              endpoint={contractSearch}
              query={{ ...query }}
              sortBy="contratista_nombre"
              searchInput
              exportCSV
            />
          </TabPane>
        </Tabs>
      )}
      <CustomButton
        type={'default'}
        className={'back-button'}
        htmlType="button"
        text={
          <Link
            to={`${INTERNAL_LINKS.POSTCONTRACTUAL}/0/${match.params.project_id}`}
          >
            Volver
          </Link>
        }
      />
      {newData && (
        <Modal
          open={!!newData}
          onCancel={() => setNewData()}
          closable={!loadingNext}
          destroyOnClose
          title={`${newData.contratista_nombre} - ${newData.tipo_identificacion} ${newData.identificacion} - Contrato No. ${newData.contrato_num}`}
          width={'80%'}
          footer={null}
        >
          <Form
            form={formModal}
            preserve={false}
            onFinish={next}
            onValuesChange={(cv, v) => {
              if (cv.hasOwnProperty('fecha_efectiva')) {
                formModal.setFieldsValue({
                  tipo_terminacion: undefined,
                  causal: undefined,
                });
              }
              if (cv.hasOwnProperty('tipo_terminacion')) {
                formModal.setFieldsValue({
                  causal: undefined,
                });
              }
            }}
          >
            <Row gutter={2}>
              <Col flex="50rem">
                Fecha de finalización contractual VIGENTE del contratista:
              </Col>
              <Col flex="auto">
                <b style={{ paddingLeft: '10px' }}>
                  {newData.fecha_fin.format('DD MMMM YYYY')}
                </b>
              </Col>
            </Row>
            <Row gutter={2}>
              <Col flex="50rem">
                Fecha efectiva (fecha de terminación de actividades del
                contratista)
                <CustomTooltip title="La fecha efectiva no puede ser mayor a hoy ni a la fecha de finalización del contrato vigente" />
                :
              </Col>
              <Col flex="auto">
                <Form.Item
                  label=""
                  name="fecha_efectiva"
                  rules={[{ required: true, message: 'Seleccione una fecha' }]}
                >
                  <DatePicker
                    format={'DD MMMM YYYY'}
                    defaultPickerValue={dayjs.min(
                      newData.fecha_fin,
                      newData.fecha_continuar,
                    )}
                    disabledDate={(c) => {
                      return (
                        c &&
                        (c.isAfter(newData.fecha_fin, 'day') ||
                          c.isBefore(newData.fecha_inicio, 'day'))
                      );
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item noStyle dependencies={['fecha_efectiva']}>
              {({ getFieldValue }) => {
                const fe = getFieldValue('fecha_efectiva');
                if (!fe) {
                  return null;
                }
                const isAnticipated = fe.isBefore(newData.fecha_fin, 'day');
                const fim = newData.fecha_continuar.isBefore(
                  newData.fecha_fin,
                  'day',
                )
                  ? fe.clone().add(newData.plazo, 'days')
                  : newData.fecha_fin.clone().add(newData.plazo, 'days');

                const isExpired = newData.fecha_continuar.isAfter(
                  newData.fecha_fin.clone().add(newData.plazo, 'days'),
                  'day',
                );
                return (
                  <>
                    <p>
                      Fecha interna máxima para la firma del acta de terminación
                      y liquidación: <b>{fim.format('DD MMMM YYYY')}</b>
                      {isExpired && <b> - Fecha Vencida</b>}
                    </p>
                    <Form.Item
                      label=""
                      name="tipo_terminacion"
                      rules={[
                        {
                          required: true,
                          message: 'Seleccione el tipo de terminación',
                        },
                      ]}
                    >
                      <Radio.Group
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-around',
                        }}
                      >
                        {isAnticipated ? (
                          <>
                            <Radio.Button value={2} disabled={isExpired}>
                              Acta Anticipada Bilateral
                            </Radio.Button>
                            <Radio.Button value={4}>
                              Acta Anticipada Unilateral
                            </Radio.Button>
                          </>
                        ) : (
                          <>
                            <Radio.Button value={1} disabled={isExpired}>
                              Acta Ordinaria Bilateral
                            </Radio.Button>
                            <Radio.Button value={3}>
                              Acta Ordinaria Unilateral
                            </Radio.Button>
                          </>
                        )}
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item noStyle dependencies={['tipo_terminacion']}>
                      {({ getFieldValue }) => {
                        const t = getFieldValue('tipo_terminacion');
                        if (!t) {
                          return null;
                        }
                        return (
                          <>
                            {[2, 4].includes(t) ? (
                              <Form.Item
                                label="Causal"
                                name="causal"
                                valuePropName="initialValue"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Seleccione una causal',
                                  },
                                ]}
                              >
                                <CustomSelector
                                  selectorProps={{
                                    style: { width: '100%' },
                                    placeholder: `Causales ${
                                      t < 3 ? 'Bilaterales' : 'Unilaterales'
                                    }`,
                                  }}
                                  endpointFetch={async () => {
                                    const filters = {};
                                    if (t > 2)
                                      filters['exclusivo_bilateral'] = false;
                                    if (!sendPerm)
                                      filters['exclusivo_legal'] = false;
                                    return await causalSelector(filters);
                                  }}
                                  key={t}
                                />
                              </Form.Item>
                            ) : null}
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              <CustomButton
                                type="primary"
                                htmlType="submit"
                                text="Generar acta"
                                disabled={loadingNext}
                                loading={loadingNext}
                              />
                            </div>
                          </>
                        );
                      }}
                    </Form.Item>
                  </>
                );
              }}
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

export default NewPostContractualForm;
